function Misc() {
  const chatLinks = document.querySelectorAll('.open-chat');
	const blogImages = document.querySelectorAll('.default-content img');

  if (chatLinks) {
    chatLinks.forEach(chatLink => {
      chatLink.addEventListener('click', function(e) {
        e.preventDefault();
        olark('api.box.expand');
      });
    });
  }

	if (blogImages) {
		blogImages.forEach(blogImage => {
			blogImage.addEventListener('error', function() {
				blogImage.classList.add('img-error');
			});
		});
	}
}

export default Misc;